export const ActionTypes = {
    SET_PRODUCTS : "SET_PRODUCTS",
    SELECTED_PRODUCT : "SELECTED_PRODUCT",
    REMOVE_SELECTED_PRODUCT : " REMOVE_SELECTED_PRODUCT",
    ADD_TO_QUOTE : "ADD_TO_QUOTE",
    REMOVE_FROM_QUOTE:'REMOVE_FROM_QUOTE',
    UPDATE_QUANTITY:'UPDATE_QUANTITY'
}